import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ConnectedProps, connect } from "react-redux";
import Common from "us.common";
import { ConfigurationProvider } from "us.common/ConfigurationContext";
import commonRoutes from "us.common/routes";
import { SignalRProvider } from "us.common/SignalRProvider";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { courtFeeRoutes } from "routes";
import { RootState } from "us.helper/types";
import { DrawerProvider } from "us.common/context";
import { useAuth } from "us.helper/hooks/useAuth";
import { Loader, LoginRedirect } from "us.common/components";

const { Page404, AppLayout, ConfigProvider } = Common.Components;

const App: React.FC<PropsFromRedux> = ({ currentLanguage }) => {
  const { isAuthenticated, isInitialized } = useAuth();

  if (!isInitialized) return <Loader />;

  // If user not authenticated after initialization, present login redirect
  if (!isAuthenticated) {
    return (
      <UnauthenticatedTemplate>
        <BrowserRouter
          future={{
            v7_relativeSplatPath: true,
          }}
        >
          <LoginRedirect />
        </BrowserRouter>
      </UnauthenticatedTemplate>
    );
  }

  return (
    <AuthenticatedTemplate>
      <BrowserRouter>
        <ConfigurationProvider>
          <SignalRProvider>
            <DrawerProvider>
              <AppLayout>
                <ConfigProvider locale={currentLanguage as any}>
                  <Routes>
                    {[...courtFeeRoutes(), ...commonRoutes]}
                    <Route path="*" element={<Page404 />} />
                  </Routes>
                </ConfigProvider>
              </AppLayout>
            </DrawerProvider>
          </SignalRProvider>
        </ConfigurationProvider>
      </BrowserRouter>
    </AuthenticatedTemplate>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    currentLanguage: state.common.currentLanguage,
  };
};
const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(App);
